'use strict';

function padLeft(str, length, prefix) {
  str = str.toString();
  if (str.length >= length) {
    return str;
  }
  for (var i = 0; i < length - str.length; i++) {
    str = prefix + str;
  }
  return str;
}

exports.readableTime = function (datestr) {
  var date = new Date(datestr);
  return date.getFullYear() + '-' + padLeft((date.getMonth() + 1), 2, '0') + '-' + padLeft(date.getDate(), 2, '0') + ' ' + padLeft(date.getHours(), 2, '0') + ':' + padLeft(date.getMinutes(), 2, '0');
};



// WEBPACK FOOTER //
// ./src/helper/dateTimeHelper.js